// extracted by mini-css-extract-plugin
export default {"Post":"Post_Post__tWnr3","header":"Post_header__d+LRG","pic":"Post_pic__P+nrM","footer":"Post_footer__5CLMC","body":"Post_body__xjYLK"};